import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const partialOrTotalBlindness: AnswerPathTreeNode = {
  path: 'partialOrTotalBlindness',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPartialOrTotalBlindnessDetails }],
};
